import React, { useContext } from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import EventList from '../../../components/EventList';
import { withTracking } from '../../../provider';
import DiscoveryContext from '../../../../../contexts/discoveryContext/contextV2';
import { getSeeAllUrl } from './utils';
import { list } from '../../../styles.module.css';

import {
  container,
  heading,
  text,
  mapMode as mapModeStyle,
  seeAllLink,
} from './styles.module.css';

const NearbyEventList = ({
  specificEventsIncluded,
  events,
  query,
  trackingSource,
  eventListClassName,
  mapProps = {},
  mapMode = false,
  injected: {
    tracking: { trackButtonClick },
  },
}) => {
  const {
    getLinkWithFilters,
    filters: {
      location: { viewport, point },
    },
  } = useContext(DiscoveryContext);

  if (!events.length) {
    return null;
  }

  const handleTracking = (name, params) => {
    trackButtonClick(name, params);
  };

  const headerText = specificEventsIncluded
    ? 'Events outside your area'
    : 'Here are some nearby events';

  const subtitleText =
    "We've found some exciting events just outside your area";

  const seeAllUrl = getSeeAllUrl({ viewport, point, getLinkWithFilters });

  return (
    <>
      <div className={classnames(container, { [mapModeStyle]: mapMode })}>
        <span className={heading}>{headerText}</span>
        {!specificEventsIncluded && (
          <span className={text}>{subtitleText}</span>
        )}
      </div>
      <EventList
        className={classnames(list, eventListClassName)}
        query={query}
        events={events}
        source={trackingSource}
        total={events.length}
        showLoadMore={false}
        hidePaginationLabel
        handleExternalTracking={handleTracking}
        {...mapProps}
      />

      {seeAllUrl && (
        <Link className={seeAllLink} to={seeAllUrl}>
          View all nearby events
        </Link>
      )}
    </>
  );
};

export default withTracking('thin_results')(NearbyEventList);
